import Vue from 'vue';
import { Component, Provide, Inject, Watch } from 'vue-property-decorator';
import util from '../../shared/util';
import template from './addressBook.vue';
import { Validator } from 'vee-validate';
import MessageModal from '../../components/messageModel';
import DefaultModal from '../../components/modal';
import UnisProductModal from '../../components/unisProductModal';
import UinsDefaultSelect from '../../components/unisDefaultSelect';
import OneButtonModal from '../../components/oneButtonModal';
import uploader from '../../components/uploader';
import ProductModal from '../../components/productModal';
import pager from '../../components/pager';
import tmsServiceBackend from '../../services/axios/tmsServiceBackend';
import { analytics } from '../../services/analytics';
import qs from 'qs';
import { cloneDeep, isNumber } from 'lodash-es';
@Component({
    mixins: [template],
    components: {
        MessageModal,
        DefaultModal,
        OneButtonModal,
        uploader,
        ProductModal,
        pager,
        UinsDefaultSelect,
        UnisProductModal,
    },
})
export default class NewAddressBook extends Vue {
    pageTitle = 'Address book';
    templateCsv = require('../../assets/files/address_import_template.csv');
    contactTemplate = require('../../assets/files/contact_import_template.csv');
    companyName: string = '';
    location_id: number;
    validationStarted: boolean = true;
    // btnSearchText: string = "Search";
    searchNotFound: boolean = false;
    isLoading = false;
    loadingModal = false;
    // errorModal
    errorModal: string = 'errorModal';

    // MessageModal
    companyModal: string = 'companyModal';
    contactModal: string = 'contactModal';
    messageModalName: string = 'messageModalName';
    messageModalTitle: string = 'Success';
    messageModalMessage: string = 'Success';

    // DefaultModal
    deleteCompanyModal: string = 'deleteCompanyModal';
    editCompanyModal: string = 'editCompanyModal';
    editCompanyModaldetal: string = 'editCompanyModaldetal';
    editCompanyModalTitle: string = '';
    editCompanyModaRightBtn: string = 'Add Company';
    editCompanyRightBtnStyle: any = {
        'background-color': '#15223d !important',
        color: '#fff !important',
    };
    viewCompanyModal: string = 'viewCompanyModal';
    editViewleftBtnStyle: any = {
        display: 'none',
    };
    editViewRightBtnStyle: any = {
        'margin-left': '140px',
    };
    addressSuggestionModal: string = 'addressSuggestionModal';
    addressRightBtnStyle: any = {
        'background-color': '#f7b020 !important',
        color: '#15223d !important',
    };
    rightBtnaddressSuggestionModal: string = 'Next';

    importModal: string = 'importModal';
    importError = false;
    importFile = {};
    importHasFile = false;
    exportFile = 0;

    // SuggestedAddress
    suggestedRadioAddress: string = '';
    bypassValidation: boolean = false;

    // items in pagination
    items: Array<Object> = [];
    contactItems: Array<Object> = [];
    pagination = {
        min: 0,
        max: 10,
        size: 2,
        currentPage: 1,
        totalCompanies: 0,
        totalPaginationCount: 0,
        paginationLink: {},
        paginationSet: {},
        currentPaginationIndex: 0,
        paginationStart: 0,
        paginationEnd: 5,
        hide: false,
    };
    ping: any = {
        pageSize: 10,
        pagesStart: 0,
        currentPage: 1,
        pagesEnd: 1,
    };

    @Provide() addressBookData: any = this.$store.getters.addressBookData;
    @Provide() locationTypeOptions: any = this.$store.getters.locationTypeOptions;
    @Provide() stateOptions: any = this.$store.getters.stateOptions;

    @Inject() $validator: Validator;

    contactSearchString = '';
    editContactModal = 'editContactModal';
    editContactModalTitle: string = '';
    editContactModalRightBtn: string = '';
    editContactModalRightBtnStyle: any = {
        'background-color': '#15223d !important',
        color: '#fff !important',
    };
    editContactData: any = {
        client_contact_id: 0,
        client_contact_company: '',
        client_contact_name: '',
        client_contact_phone: '',
        client_contact_email: '',
        client_contact_job_capacity: '',
        client_contact_title: '',
        client_contact_role: '',
    };

    deleteContactModal = 'deleteModal';
    deleteContactModalTitle = 'Delete this contact?';
    deleteContactData: any;

    async created() {
        this.isLoading = true;
        let response = await this.$store.dispatch('getAddressBookData');
        this.isLoading = false;
        if (response) {
            this.items = this.addressBookData.addressList;
            if (this.items.length <= 10) {
                this.pagination.hide = true;
            } else {
                this.pagination.hide = false;
            }
            this.generatePaginationObject(this.items.length);
        }
    }

    async searchCompany() {
        this.isLoading = true;
        this.initInfo();
        let response = await this.$store.dispatch('searchCompany', this.companyName);
        this.isLoading = false;
        if (response && response.address_book != 0) {
            this.items = this.addressBookData.addressList;
            if (this.items.length > 0) {
                this.searchNotFound = false;
                if (this.items.length <= 10) {
                    this.pagination.hide = true;
                } else {
                    this.pagination.hide = false;
                }
                this.generatePaginationObject(this.items.length);
                this.updatePaginationModel(0);
            } else {
                this.searchNotFound = true;
            }
        } else {
            this.searchNotFound = true;
        }
    }

    initInfo() {
        this.pagination = {
            min: 0,
            max: 10,
            size: 1,
            currentPage: 1,
            totalCompanies: 0,
            totalPaginationCount: 0,
            paginationLink: {},
            paginationSet: {},
            currentPaginationIndex: 0,
            paginationStart: 0,
            paginationEnd: 5,
            hide: false,
        };
        this.items = [];
        this.contactItems = [];
    }

    editCompany(location_id: any) {
        if (location_id == 0) {
            // add
            this.editCompanyModalTitle = 'Add New Company';
            this.editCompanyModaRightBtn = 'Add Company';
            this.$store.commit('resetCompanyData');
        } else {
            // edit
            this.editCompanyModalTitle = 'Edit Company Details';
            this.editCompanyModaRightBtn = 'Save Changes';
            this.$store.commit('updateCompanyData', location_id);
            this.$modal.hide(this.viewCompanyModal);
        }
        this.$modal.show(this.editCompanyModal);
        this.$modal.hide(this.viewCompanyModal);
    }

    deleteCompany(location_id: any) {
        this.location_id = location_id;
        this.$store.commit('updateCompanyData', location_id);
        this.$modal.show(this.deleteCompanyModal);
        this.$modal.hide(this.viewCompanyModal);
    }

    viewCompany(location_id: any) {
        this.$store.commit('updateCompanyData', location_id);
        this.$modal.show(this.viewCompanyModal);
    }

    async confirmModal(modal_name: any, is_address_validated: boolean = false) {
        if (modal_name == 'del') {
            if (this.pageTitle == 'Address book') {
                let response = await Promise.all([
                    this.$store.dispatch('deleteCompany', this.location_id),
                ]);
                let success = response[0].data.success;
                if (success > 0) {
                    this.$modal.hide(this.deleteCompanyModal);
                    this.searchCompany();
                } else {
                    // error here
                    this.$modal.show(this.errorModal);
                }
            } else {
                // console.log('delete contact');
            }
        } else if (modal_name == 'edit') {
            let action = this.addressBookData.companyData.locationId == 0 ? 'add' : 'edit';
            let validate = await this.$validator.validateAll();
            if (!validate && this.suggestedRadioAddress == 'inputted') {
                // bypass validation when select inputted address
                validate = true;
            }
            if (validate) {
                // if adding new company lets check for address auto suggestion
                if (action == 'add') {
                    if (!is_address_validated) {
                        if (await this.$store.dispatch('validateLocationALK')) {
                            this.$modal.hide(this.editCompanyModal);
                            this.showAddressSuggestionModal();
                        }
                    } else {
                        // store update to form
                        this.$store.commit('updateNewCompanyData', this.suggestedRadioAddress);
                        // adding  new company
                        this.messageModalMessage = 'Company has been saved to your Address Book.';
                        this.saveCompany();
                    }
                } else {
                    // edit existing company
                    this.messageModalMessage = 'Company has been updated.';
                    this.saveCompany();
                }
            }
        }
    }

    async saveCompany() {
        this.$modal.hide(this.editCompanyModal);
        this.$modal.hide(this.addressSuggestionModal);

        let response = await Promise.all([this.$store.dispatch('updateCompany')]);
        let location_id = response[0].data.location_id;
        if (location_id > 0) {
            this.$modal.show(this.messageModalName);
            this.searchCompany();
            this.suggestedRadioAddress = '';
        } else {
            // error here
            this.$modal.show(this.errorModal);
            this.suggestedRadioAddress = '';
        }
    }

    closeModal(modal_name: any) {
        if (modal_name == 'del') {
            this.$modal.hide(this.deleteCompanyModal);
        } else if (modal_name == 'edit') {
            this.$modal.hide(this.editCompanyModal);
        } else {
            this.$modal.hide(modal_name);
        }
        this.suggestedRadioAddress = '';
    }

    closeErrorModal() {
        this.$modal.hide(this.errorModal);
    }

    showAddressSuggestionModal() {
        this.suggestedRadioAddress = 'inputted';
        if (!this.addressBookData.suggestedAddress.Address) {
            this.rightBtnaddressSuggestionModal = 'Submit';
        } else {
            this.rightBtnaddressSuggestionModal = 'Next';
        }
        this.$modal.show(this.addressSuggestionModal);
    }

    // pagination start here

    updatePaginationModel(paginationIndex: any) {
        this.pagination.currentPaginationIndex = paginationIndex;
        this.pagination.min = this.pagination.paginationSet[paginationIndex].min;
        this.pagination.max = this.pagination.paginationSet[paginationIndex].max;
        this.updatePaginationLink(paginationIndex);
    }

    incrementPagination() {
        if (this.pagination.currentPaginationIndex + 1 <= this.pagination.totalPaginationCount) {
            this.pagination.currentPaginationIndex++;
            this.updatePaginationModel(this.pagination.currentPaginationIndex);
        }
    }

    decrementPagination() {
        if (this.pagination.currentPaginationIndex - 1 >= 0) {
            this.pagination.currentPaginationIndex--;
            this.updatePaginationModel(this.pagination.currentPaginationIndex);
        }
    }

    updatePaginationLink(paginationIndex: any) {
        let limiter: number = 4;
        let offset: number = 2;
        let link: object[] = [];

        paginationIndex += 1;

        if (paginationIndex >= limiter) {
            let start: number = paginationIndex - offset;
            let end: number = paginationIndex + offset;

            this.pagination.paginationStart = start;
            this.pagination.paginationEnd = end;

            for (let i: number = start; i <= end - 1; i++) {
                link.push({
                    value: i,
                    index: i - 1,
                });
                if (i == this.pagination.totalPaginationCount) {
                    break;
                }
            }
        } else {
            for (let i: number = 1; i <= this.pagination.totalPaginationCount; i++) {
                if (i <= limiter) {
                    link.push({
                        value: i,
                        index: i - 1,
                    });
                } else {
                    break;
                }
            }
        }
        this.pagination.paginationLink = link;
        this.ping.pagesStart = 0;
        this.ping.currentPage = 1;
        this.filterItems(this.ping.pagesStart, this.ping.pageSize);
    }

    generatePaginationObject(totalRows: number) {
        // Each pagination has 10 rows each.
        let group: number = Math.floor(totalRows / 10);
        // Fetch any mod remainder from total rows.
        let end: number = totalRows % 10;
        let min: number = 1;
        let max: number = 10;
        let pagiObject: object[] = [];

        // If total rows has a mod remainder, add an extra pagination value to accomodate extra rows.
        if (end > 0) {
            group += 1;
        }

        this.pagination.totalPaginationCount = group;

        for (let i: number = 1; i <= group; i++) {
            if (i == group) {
                if (end > 0) {
                    max = min + end - 1;
                }

                this.pagination.totalCompanies = max;
            }

            pagiObject.push({
                min: min,
                max: max,
            });

            min += 10;
            max += 10;
        }

        this.pagination.paginationSet = pagiObject;
        this.updatePaginationLink(0);
    }

    // pagination end here
    @Watch('importFile')
    onHasImportFile(val: any, oldVal: any, event: any) {
        if (val[0]) {
            this.importHasFile = true;
        } else {
            this.importHasFile = false;
        }
    }
    importModalShow() {
        this.importFile = {};
        this.importError = false;
        this.$modal.show(this.importModal);
    }

    ExportFileAciton() {
        let url;
        let filename: any;
        this.loadingModal = true;
        let paramer = qs.stringify({
            companyName: this.companyName,
            exportFile: 1,
        });
        let date = new Date(+new Date() + 8 * 3600 * 1000)
            .toJSON()
            .substr(0, 19)
            .replace('T', '');
        if (this.pageTitle == 'Address book') {
            url = '/address/getAddressList?' + paramer;
            filename = 'address_export_' + date + '.csv';
        } else {
            url = '/clientContact/export';
            filename = 'contact_export_' + date + '.csv';
        }

        tmsServiceBackend.get(url).then(res => {
            let result = res.data;
            if (result.status != 0) {
                result = '\ufeff' + result;
                let blob = new Blob([result], { type: 'application/vnd.ms-excel' });
                let downloadUrl = URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.href = downloadUrl;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                analytics.trackFileDownload({
                    fileName: this.pageTitle == 'Address book'
                        ? 'address_book_export'
                        : 'contact_export',
                    fileType: 'csv',
                });
            } else {
                this.messageModalTitle = 'Error';
                this.messageModalMessage = result.message ? result.message : 'Service error';
                this.$modal.show(this.messageModalName);
            }
            this.loadingModal = false;
        });
    }
    importFileAction() {
        if (!this.importFile[0]) {
            this.err('Please select a CSV file'!);
            return;
        }
        let suffix = this.importFile[0]['name'].lastIndexOf('.');
        let ext = this.importFile[0]['name'].substr(suffix + 1);
        if (ext != 'csv') {
            this.err('Please select a CSV file'!);
            return;
        }
        if (this.pageTitle == 'Address book') {
            let formData = new FormData();
            formData.append('file', this.importFile[0]);
            tmsServiceBackend
                .post('/address/importAddress', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                    transformRequest: [
                        data => {
                            return data;
                        },
                    ],
                })
                .then(res => {
                    let result = res.data;
                    if (result.status) {
                        this.searchCompany();
                        this.messageModalMessage = 'Import the file successfully';
                        this.messageModalTitle = 'Success';
                        this.$modal.show(this.messageModalName);
                        this.$modal.hide(this.importModal);
                        this.deleteFile();
                    } else {
                        this.importError = true;
                    }
                })
                .catch(error => {});
        } else {
            let formData = new FormData();
            formData.append('file', this.importFile[0]);
            tmsServiceBackend
                .post('/clientContact/import', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                    transformRequest: [
                        data => {
                            return data;
                        },
                    ],
                })
                .then(res => {
                    let result = res.data;
                    if (result.status) {
                        this.getContactList();
                        this.messageModalMessage = 'Import the file successfully';
                        this.messageModalTitle = 'Success';
                        this.$modal.show(this.messageModalName);
                        this.$modal.hide(this.importModal);
                        this.deleteFile();
                    } else {
                        this.importError = true;
                    }
                })
                .catch(error => {});
        }
    }

    addFile(file: any) {
        let suffix = file[0]['name'].lastIndexOf('.');
        let ext = file[0]['name'].substr(suffix + 1);
        if (ext != 'csv') {
            this.err('Please select a CSV file'!);
            return;
        }
        this.importFile = file;
    }
    uploadFile(file: any) {
        this.importFile = file;
    }

    deleteFile() {
        this.importHasFile = false;
        this.importFile = {};
        this.importError = false;
    }

    changePage(pageTitle: any) {
        this.pageTitle = pageTitle;
        this.companyName = '';
        this.contactSearchString = '';
        if (pageTitle == 'Address book') {
            this.searchCompany();
        } else {
            this.getContactList();
        }
    }

    getContactList() {
        this.initInfo();
        this.isLoading = true;
        this.searchNotFound = false;
        let dataString =
            '?user_id=' +
            localStorage.getItem('UserID') +
            '&company_id=' +
            localStorage.getItem('company_id');
        tmsServiceBackend.get('/clientContact/getList' + dataString).then(response => {
            this.isLoading = false;
            this.processResponse(response.data);
        });
    }

    processResponse(response: any) {
        if (response.status == 1 && Array.isArray(response.data)) {
            if (response.data.length > 0) {
                this.contactItems = response.data;
                this.searchNotFound = false;
                if (this.contactItems.length <= 10) {
                    this.pagination.hide = true;
                } else {
                    this.pagination.hide = false;
                }
                this.generatePaginationObject(this.contactItems.length);
                this.updatePaginationModel(0);
            } else {
                this.contactItems = [];
                this.searchNotFound = true;
            }
        } else {
            this.searchNotFound = true;
        }
    }

    editContact(item: any) {
        this.editContactData = {
            client_contact_id: 0,
            client_contact_company: '',
            client_contact_name: '',
            client_contact_phone: '',
            client_contact_email: '',
            client_contact_job_capacity: '',
            client_contact_title: '',
            client_contact_role: '',
        };
        if (item && item.client_contact_id > 0) {
            // edit
            Object.assign(this.editContactData, item);
            this.editContactModalTitle = 'Edit Contact';
            this.editContactModalRightBtn = 'Save';
        } else {
            // add
            this.editContactModalTitle = 'Add Contact';
            this.editContactModalRightBtn = 'Save';
        }
        this.$modal.show(this.editContactModal);
    }

    deleteContact(item: any) {
        this.deleteContactData = item;
        // console.log(this.deleteContactData);
        this.$modal.show(this.deleteContactModal);
    }

    deleteHandle(id: any) {
        let formData = {
            client_contact_id: id,
        };
        tmsServiceBackend.post('/clientContact/delete', qs.stringify(formData)).then(response => {
            if (response.data.status === 1) {
                this.$modal.hide(this.deleteContactModal);
                this.getContactList();
            }
        });
    }

    async saveContact() {
        let result = await this.$validator.validateAll();
        this.editContactData.client_contact_phone = this.editContactData.client_contact_phone.replace(
            /-/g,
            ''
        );
        if (result) {
            if (this.editContactData.client_contact_id == 0) {
                tmsServiceBackend
                    .post('/clientContact/store', qs.stringify(this.editContactData))
                    .then(response => {
                        let res = response.data;
                        if (res.status) {
                            this.$modal.hide(this.editContactModal);
                            this.getContactList();
                        } else {
                            this.messageModalMessage = res.message ? res.message : 'System error';
                            this.messageModalTitle = 'Error';
                            this.$modal.show(this.messageModalName);
                        }
                    });
            } else {
                tmsServiceBackend
                    .post('/clientContact/update', qs.stringify(this.editContactData))
                    .then(response => {
                        let res = response.data;
                        if (res.status) {
                            this.$modal.hide(this.editContactModal);
                            this.getContactList();
                        } else {
                            this.messageModalMessage = res.message ? res.message : 'System error';
                            this.messageModalTitle = 'Error';
                            this.$modal.show(this.messageModalName);
                        }
                    });
            }
        }
    }

    searchContact() {
        if (this.isLoading) {
            return;
        }
        if (this.contactSearchString == '') {
            this.getContactList();
            return;
        }
        let formData = {
            search_string: this.contactSearchString,
        };
        this.isLoading = true;
        this.searchNotFound = false;
        this.initInfo();
        tmsServiceBackend.post('/clientContact/search', qs.stringify(formData)).then(response => {
            this.isLoading = false;
            this.processResponse(response.data);
        });
    }

    closeContactEditModal() {
        this.$modal.hide(this.editContactModal);
    }

    DownloadFile(url: string, name: string) {
        util.exportFile(url, name);
        analytics.trackFileDownload({
            fileName: this.pageTitle == 'Address book'
                ? 'address_book_template'
                : 'contact_template',
            fileType: 'csv',
        });
    }
    itemsSlice: Array<any> = [];
    contactItemsSlice: Array<any> = [];
    totalCount: any = '';

    filterItems(index: any, size: any) {
        if (this.pageTitle == 'Address book') {
            this.totalCount = isNumber(this.items.length) ? this.items.length : 0;
            this.itemsSlice = isNumber(this.items.length)
                ? cloneDeep(this.items).slice(index, size)
                : [];
            return;
        }

        this.totalCount = this.contactItems.length;
        this.contactItemsSlice = cloneDeep(this.contactItems).slice(index, size);
    }

    triggerSearchFromPager(page: any) {
        this.filterItems(
            (page.currentPage - 1) * this.ping.pageSize,
            page.currentPage * this.ping.pageSize
        );
    }
    companyDetail: any = {};
    contactDetail: any = {};
    companyView(item: any) {
        this.companyDetail = item;
        this.$modal.show(this.companyModal);
    }

    contactView(item: any) {
        this.contactDetail = item;
        this.$modal.show(this.contactModal);
    }

    closeContactModal() {
        this.$modal.hide(this.contactModal);
    }

    closeCompanyModal() {
        this.$modal.hide(this.companyModal);
    }

    editContactForModal() {
        this.$modal.hide(this.contactModal);
        this.editContact(this.contactDetail);
    }

    editCompanyForModal() {
        this.$modal.hide(this.companyModal);
        this.editCompany(this.companyDetail);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/newAddressBook/index.ts